var path = 'app/components/common/forms/templates/horizontalLabel.html';
var html = "<label ng-if=\"to.label\" for=\"{{::id}}\" class=\"{{::to.labelcss || 'col-md-3'}} control-label\">{{to.label}} {{to.required ? \"*\" : \"\"}}</label><div class=\"{{::to.controllCss || 'col-md-9'}}\"><formly-transclude></formly-transclude></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/common/forms/templates/horizontalLabel.html
// module id = 318
// module chunks = 0